import {inject, Injectable} from '@angular/core';
import {StyleFunction} from 'ol/style/Style';
import {map, Observable} from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import {MapGroup} from '../shared/classes/map-group';
import {MapLayer} from '../shared/classes/map-layer';
import BaseLayer from 'ol/layer/Base';


@Injectable({
  providedIn: 'root',
})
export class LayerService {

  private http = inject(HttpClient);


  public styles = new Map<string, StyleFunction>();

  constructor() {
  }

  getLayerGroups(): Observable<MapGroup[]> {
    const endpoint = '/api/maplayer/groups';
    return this.http.get<MapGroup[]>(endpoint).pipe(
      map(groups => groups.map(group => new MapGroup(group))),
    );
  }


  public getJsonData<D>(url: string, queryParams?: Record<string, string | number | boolean>): Observable<D> {
    let params = new HttpParams();

    if (queryParams) {
      Object.keys(queryParams).forEach(key => {
        params = params.set(key, queryParams[key]);
      });
    }

    return this.http.get<D>(url, {params});
  }


  // public getGeoserverFeatureAtCoordinate(mapLayer: MapLayer, lat: number, lon: number): Observable<PopoverData[]> {
  public getGeoserverFeatureAtCoordinate(url: string): Observable<unknown> {
    return this.http.get(url);
  }


  public getWfsJsonData(geoserverUrl: string, geoserverLayerName: string, cqlFilter?: string): Observable<Record<string, unknown>[]> {
    const url = geoserverUrl.replace('wms', 'wfs');
    let params = new HttpParams()
      .set('REQUEST', 'GetFeature')
      .set('SERVICE', 'WFS')
      .set('outputFormat', 'application/json')
      .set('typeName', geoserverLayerName);

    if (cqlFilter) {
      params = params.append('cql_filter', cqlFilter);

    }


    return this.http.get<{features: Record<string, unknown>[]}>(url, {params}).pipe(
      map(fc => fc.features),
    );
  }

  public updateLayerGroup(layerGroup: MapGroup): Observable<MapGroup> {
    const url = `api/maplayer/group/${layerGroup.id}`;
    return this.http.put<MapGroup>(url, layerGroup).pipe(
      map(layerGroup => new MapGroup(layerGroup)),
    );
  }

  public updateLayer(layer: MapLayer): Observable<MapLayer> {
    const url = `api/maplayer/${layer.id}`;
    return this.http.put<MapLayer>(url, layer).pipe(
      map(response => new MapLayer(response)),
    );
  }

  public getMapLayerByHandle(uiHandle: string): Observable<MapLayer<BaseLayer>> {
    const url = `api/maplayer/handle/${uiHandle}`;
    return this.http.get<MapLayer<BaseLayer>>(url).pipe(
      map(response => new MapLayer(response)),
    );
  }
}
